import {
  PostCardFragmentFragment,
  RepostCardFragmentFragment,
  TournamentPostCardFragmentFragment,
} from '@/__generated__/graphql.ts';
import { TournamentLabel } from '../post-label/tournament-label.tsx';
import { PostCardShareActionsMenu } from './post-card-actions/post-card-share-actions-menu.tsx';
import {
  postCardActions,
  postCardFooter,
  postCardLabels,
} from './post-card.css.ts';

export const PostCardFooter = ({
  post,
}: {
  post:
    | PostCardFragmentFragment
    | RepostCardFragmentFragment
    | TournamentPostCardFragmentFragment;
}) => {
  const postContent =
    (post as RepostCardFragmentFragment)?.originalPost || post;

  const label =
    (postContent as unknown as TournamentPostCardFragmentFragment)?.tournament
      ?.label || undefined;

  const tournamentId = (
    postContent as unknown as TournamentPostCardFragmentFragment
  )?.tournament?.id;

  return (
    <div className={postCardFooter}>
      {label ? (
        <div className={postCardLabels} onClick={(e) => e.stopPropagation()}>
          <TournamentLabel
            label={label}
            tournamentId={tournamentId}
            linkToTournament
          />
        </div>
      ) : null}
      <div className={postCardActions} onClick={(e) => e.stopPropagation()}>
        <PostCardShareActionsMenu post={postContent} />
      </div>
    </div>
  );
};
